module.exports = __webpack_public_path__ + "media/src/assets/Images/UploadFileFilled-99273f2e025dd9919f4f7ebaa3ec16b0.svg";